import React, { useCallback } from "react";
import { WithFeatureGate } from "../WithFeatureGate";

export type WithFeatureGateEnabledProps = Readonly<{
  featureGate: string;
  children: JSX.Element | null;
}>;

export const WithFeatureGateEnabled = ({ featureGate, children }: WithFeatureGateEnabledProps) => {
  const renderChildren = useCallback(() => children, [children]);

  return <WithFeatureGate featureGate={featureGate} renderEnabled={renderChildren} />;
};
